import { http } from '@/services'

export const documentActions = {
  methods: {
    markInStorage () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'in_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markSentToUser () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'sent_to_user', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markSentToBusiness () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'sent_to_business', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markSentToStorage () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'sent_to_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
        this.$vs.notify({
          title:'Success',
          text:'Documents marked as sent to storage',
          color:'success'
        })
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markNotSentToStorage () {
      if (!this.selected.length) return
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'not_sent_to_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
        this.$vs.notify({
          title:'Success',
          text:'Documents marked as created',
          color:'success'
        })
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markRequestedFromStorage () {
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'requested_from_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    markCancelRetrievalFromStorage () {
      var documentIds = this.selected.map(doc => doc.id)
      var data = {action: 'cancel_request_from_storage', data: documentIds}

      http.patch('paper_documents_list', data).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    },
    deleteSentToStorage () {
      var documentIds = this.selected.map(doc => doc.id)

      http.delete('paper_documents_list', {params: { documentIds }}).then(
      response => {
        this.$emit('update')
        this.selected = []
      }
      ).catch(
      error => {
        console.log(error)
      }
      )
    }
  }
}
